'use client';
import { useManagerEntity } from '@/shared/managerHelpers';
import { useTour } from '@reactour/tour';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { PiPianoKeysFill, PiStudentFill } from 'react-icons/pi';
import { TooltipToggleMode } from './Tooltips/TooltipToggleMode';

const baseButtonClasses = ` inline-flex items-center justify-center whitespace-nowrap
          rounded-sm px-1 lg:px-3 py-1 lg:py-1.5
          ring-offset-background transition-all
          focus-visible:outline-none focus-visible:ring-2
          focus-visible:ring-ring focus-visible:ring-offset-2
          disabled:pointer-events-none disabled:opacity-50
          cursor-pointer`;

type ToggleModeProps = {
  mode: 'Play' | 'Practice';
  setMode: (mode: 'Play' | 'Practice') => void;
};

function ToggleMode({ mode, setMode }: ToggleModeProps) {
  const { t } = useTranslation();
  const ManagerEntity = useManagerEntity();
  const manager = ManagerEntity;
  const { currentStep, setCurrentStep, isOpen: isTourOpen } = useTour();

  const playerState = ManagerEntity?.player?.state;

  useEffect(() => {
    if (isTourOpen && currentStep === 4 && mode === 'Play') {
      setTimeout(() => {
        setCurrentStep(5);
      }, 300);
    }
  }, [mode, isTourOpen, currentStep, setCurrentStep]);

  return (
    <div className='rounded-md p-1 border flex items-center flex-none text-base font-medium'>
      <TooltipToggleMode mode='Play'>
        <button
          data-testid='start_play_mode'
          onClick={() => {
            setMode('Play');
            console.log('**Play mode clicked');
            console.log('**Current playerState:', playerState);

            const playMode = manager?.practiceModes.find(
              (m: any) => m.id === 1
            );
            console.log('*switched to:', playMode);
            console.log('*Practice modes:', manager.practiceModes);

            manager.selectedPracticeMode = playMode;
            if (!playMode) {
              console.error('Play mode is not found');
              throw new Error('Play mode is not found');
            }
          }}
          className={`
              ${baseButtonClasses}
            ${
              mode === 'Play'
                ? 'bg-accent-blue text-white'
                : 'bg-white text-black  hover:text-zinc-800'
            }
          `}
        >
          <span className='hidden lg:inline leading-[22px]' suppressHydrationWarning>
            {t('mode.play_enable')}
          </span>
          <PiPianoKeysFill className='lg:hidden' size={26} />
        </button>
      </TooltipToggleMode>
      <TooltipToggleMode mode='Practice'>
        <button
          data-testid='start_practice_mode'
          onClick={() => {
            setMode('Practice');

            console.log('**Practice mode clicked');
            console.log('**Current playerState:', playerState);
            const practiceMode = manager?.practiceModes.find(
              (m: any) => m.id === 0
            );

            manager.selectedPracticeMode = practiceMode;

            console.log('*switched to:', practiceMode);
            console.log('*Practice modes:', manager.practiceModes);
            if (!practiceMode) {
              console.error('Practice mode is not found');
              throw new Error('Practice mode is not found');
            }
            //         audioPlayerModel.play();
            console.log('**Practice mode clicked');
            console.log('**Current playerState:', playerState);

            // kolya approach
            // playbackControlModel.startPractice()
          }}
          className={`
              ${baseButtonClasses}
          ${
            mode === 'Practice'
              ? 'bg-accent-blue text-white'
              : 'bg-white text-black hover:text-zinc-800'
          }
        `}
        >
          <span className='hidden lg:inline leading-[22px]' suppressHydrationWarning>
            {t('mode.practice_enable')}
          </span>
          <PiStudentFill className='lg:hidden' size={26} />
        </button>
      </TooltipToggleMode>
    </div>
  );
}

export default ToggleMode;
